module.exports = __webpack_public_path__ + "img/alert-ok-img.8e296252.png";